/* eslint-disable */
import React, { useContext, useState } from 'react';

import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Layout, Menu, Button } from 'antd';
// import { useTheme } from 'utils/Theme';
import { Container, Logo, LogoutButtonContainer, LogoContainer } from './Dashboard.style';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import { AuthStoreContext } from 'store/AuthStore';

const { Header, Content, Footer, Sider } = Layout;

export interface DashboardProps {
  children?: React.ReactNode;
}

const DashboardLayout = (props: DashboardProps): JSX.Element => {
  // MARK:- Store
  const authStore = useContext(AuthStoreContext)

  // MARK:- Hooks
  const navigate = useNavigate()
  const location = useLocation()

  // MARK:- State
  const [collapsed, setCollapsed] = useState<boolean>(false);

  // MARK:- Functions
  function onCollapse(collapse: boolean) {
    setCollapsed(collapse);
  }

  function onClickLink(path: string) {
    navigate(`/dashboard/${path}`)
  }

  function onClickLogout() {
    authStore.logout()
  }

  const currentInnerRoute = location.pathname.split('/')[2]

  return (
    <Container>
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
          <LogoContainer>
            <Logo
              src="https://trello-attachments.s3.amazonaws.com/602532c51bd99d8afa282e34/602fb4ade48e1525bb666ac7/d3553f450bbc503227eb898472d6b3b8/Pri_A_YB%404x-100.jpg"
              alt="" />
          </LogoContainer>

          <Menu theme="dark" mode="inline" selectedKeys={[currentInnerRoute]}>
            {authStore.userType === 'CONSULTANT' ?
              <>
                <Menu.Item key="enrollment-forms" icon={<PieChartOutlined />} onClick={() => onClickLink('enrollment-forms')}>
                  Enrollment Forms
                </Menu.Item>
                <Menu.Item key="survey" icon={<DesktopOutlined />} onClick={() => onClickLink('survey')}>
                  Assessment
                </Menu.Item>
                <Menu.Item key="profile" icon={<FileOutlined />} onClick={() => onClickLink('profile')}>
                  Profile
                </Menu.Item>
              </>
              : <>
                <Menu.Item key="user-management" icon={<UserOutlined />} onClick={() => onClickLink('user-management')}>
                  User Management
                </Menu.Item>
                <Menu.Item key="profile" icon={<FileOutlined />} onClick={() => onClickLink('profile')}>
                  Profile
                </Menu.Item>
              </>
            }
          </Menu>
          <LogoutButtonContainer>
            <Button type="primary" onClick={onClickLogout}>Logout</Button>
          </LogoutButtonContainer>
        </Sider>

        <Layout className="site-layout">
          <Header className="site-layout-background" style={{ padding: 0 }} />
          <Content style={{ margin: '0 16px' }}>
            {/* <Breadcrumb style={{ margin: '16px 0' }}>
            <Breadcrumb.Item>Enrollment Form</Breadcrumb.Item>
          </Breadcrumb> */}
            <div
              className="site-layout-background"
              style={{ padding: 24, minHeight: 360, marginTop: 24 }}
            >
              <Outlet />
            </div>
          </Content>
        </Layout>
      </Layout>
    </Container>
  );
};

export default DashboardLayout;
